/**
 * Custom remove method to remove view from the DOM
 * @returns {Backbone.View}
 */
Backbone.View.prototype.remove = function () {
    'use strict';

    this.undelegateEvents();
    this.$el.empty();
    this.stopListening();
    return this;
};

/**
 * Close view to prevent zombies on backbone
 * This method should be called when view is no longer displayed
 */
Backbone.View.prototype.close = function () {
    'use strict';

    /**
     * Remove the view from the DOM and unbind jQuery element
     */
    this.remove();

    /**
     * Unbind any event attached by this view
     */
    this.unbind();

    /**
     * When onClose exist, execute it
     * The purpose of this code is to enable a custom on close method
     */
    if (this.onClose) {
        this.onClose();
    }

    return this;
};

/**
 * Listen to media
 * @description
 *
 * listen to media by add the listener to your 'initialize' function
 * inside a Backbone.View, like the example above:
 *
 *      initialize: function () {
 *          this.listenToMedia(this.onMediaChange);
 *      }
 *
 *      onMediaChange: function (media) {
 *          switch (media) {
 *              case 'desktop':
 *                  this.renderDesktop();
 *                  break;
 *          }
 *      }
 *
 * Once you turned-on the listener, you can use the method below to get
 * the current media type:
 *
 *      var myCurrentMedia = this.getCurrentMedia();
 *
 * @param {Function} callback
 * @returns {Backbone.Model}
 */
Backbone.View.prototype.listenToMedia = function (callback) {
    'use strict';

    this.screenMedia = this.getCurrentMedia();

    /**
     * Fire media listener
     */
    this.fireMediaListener = function () {
        var media = this.getCurrentMedia();
        if (this.screenMedia !== media) {
            this.screenMedia = media;
            callback(this.screenMedia);
        }
    };

    /**
     * Register resize event
     */
    if (callback) {
        jQuery(window).on('resize.listenToMedia', this.fireMediaListener.bind(this));
    }

    return this;
};

/**
 * Get the current media by resolution
 * @returns {*}
 */
Backbone.View.prototype.getCurrentMedia = function () {
    'use strict';

    /**
     * Find between media screen resolutions
     * @param {number} x - current resolution number
     * @param {Array} media - array win min and max resolution numbers
     * @returns {boolean}
     */
    function between(x, media) {
        return x >= media[0] && x <= media[1];
    }

    /**
     *
     */
    for (var device in globals.media.devices) {
        if (between(window.innerWidth, globals.media.devices[device])) {
            return device;
        }
    }

    return globals.media.default;
};
